module.exports = __webpack_public_path__ + "media/images/sports_icons/rowing-d55dfa736700d518c386c84b50e1e60e.png";